import React from "react";
import { Link } from "react-router-dom";

function OpenStudioCard({ studio }) {
  const presenterColorClasses = [
    "txt-gradient-1",
    "txt-gradient-2",
    "txt-gradient-3",
    "txt-gradient-4",
    "txt-gradient-5",
    "txt-gradient-6",
  ];

  const presenterClass =
    presenterColorClasses[Math.abs(Number(studio.id) || 0) % presenterColorClasses.length];

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="package-card-beta openstudio-card">
      <div className="package-thumb openstudio-card-thumb">
        <Link
          to={studio.url}
          onClick={scrollTop}
          aria-label={`View ${studio.title} with ${studio.presenter}`}
        >
          {studio.image ? (
            <img
              src={studio.image}
              alt={`${studio.title} with ${studio.presenter}`}
              loading="lazy"
            />
          ) : (
            <div className="openstudio-card-placeholder" aria-hidden="true" />
          )}
        </Link>

        <p className="card-lavel openstudio-card-label">
          <i className="bi bi-calendar-event" />{" "}
          <span className="card-lavel-t1">{studio.date_label}</span>
          <br />
          <i className="bi bi-clock" />{" "}
          <span className="card-lavel-t1">
            {studio.time_label} {studio.timezone_label}
          </span>
        </p>
      </div>

      <div className="package-card-body">
        <h3 className="p-card-title">
          <Link to={studio.url} onClick={scrollTop}>
            {studio.title} with{" "}
            <span className={presenterClass}>{studio.presenter}</span>
          </Link>
        </h3>

        {studio.excerpt && <p className="openstudio-card-excerpt">{studio.excerpt}</p>}

        <div className="p-card-bottom openstudio-card-bottom">
          <div className="book-btn">
            <Link to={studio.url} onClick={scrollTop}>
              View / join <i className="bx bxs-right-arrow-alt" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OpenStudioCard;
